<div class="w-100">
  <div class="d-flex header-holder justify-content-between align-items-center py-3">
    <div class="d-flex justify-content-start align-items-center">
      <div class="logo">
          <img class="logo" src="/assets/binst-icon.png" alt="logo">
      </div>
      <span class="ms-3">BINST</span>
    </div>
    <div></div>
    <div class="d-flex justify-content-end align-items-center">
        <input (ngModelChange)="searchKeyPressed($event)" (keydown.enter)="enterPressed($event)" [(ngModel)]="searchText"
               class="me-5 input input-round search" placeholder="Search" />
      <div class="d-flex align-items-center cursor-pointer placeholder-glow" (click)="setProfileActive()">
        <span class="mx-3 " [class.placeholder]="!user" >{{ user?.display_name ?? "Loading... Loading" }}</span>
          <div class="profile">
              <profile-image></profile-image>
          </div>
      </div>
    </div>
  </div>
</div>
